import { Stack, Typography } from '@mui/material';
import styled from 'styled-components';

export const Title = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  color: ${({ theme }) => theme.palette.black.main};
`;

export const TitleWordStrong = styled.strong`
  color: ${({ theme }) => theme.palette.error.main};
`;

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin: 10px 0;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Row = styled(Stack)<{ $margin: string }>`
  width: 100%;
  flex-direction: row;
  gap: 8px;
  margin: ${({ $margin }) => $margin};
  padding: 2px 0;
`;

export const Label = styled(Typography)`
  width: 100%;
  max-width: 140px;
  color: ${({ theme }) => theme.palette.black.main}de !important;
  font-size: 0.875rem;
`;

export const Value = styled(Typography)`
  width: 100%;
  color: ${({ theme }) => theme.palette.black.main}de !important;
  font-size: 0.875rem;
`;

export const MessageError = styled(Typography)`
  color: ${({ theme }) => theme.palette.error.main} !important;
  font-size: 0.875rem;
  max-width: 320px;
`;
